import React, { memo, useEffect, useRef } from 'react';
import { models } from 'powerbi-client';

const DashBordPowerBI = memo(
  ({ id, token, url, showFilterNav, exibeEdicao, powerbi, setAlert, onReportReady, onTokenExpired }) => {
    const containerRef = useRef(null);
    const reportInstanceRef = useRef(null);

    const onReportReadyRef = useRef(onReportReady);
    const onTokenExpiredRef = useRef(onTokenExpired);
    useEffect(() => {
      onReportReadyRef.current = onReportReady;
    }, [onReportReady]);
    useEffect(() => {
      onTokenExpiredRef.current = onTokenExpired;
    }, [onTokenExpired]);

    useEffect(() => {
      if (!id || !token || !url || !containerRef.current) return;
      const podeEditar = exibeEdicao === true;

      powerbi.reset(containerRef.current);
      const reportRef = powerbi.embed(containerRef.current, {
        type: 'report',
        tokenType: models.TokenType.Embed,
        accessToken: token,
        embedUrl: url,
        id,
        viewMode: podeEditar ? models.ViewMode.Edit : models.ViewMode.View,
        permissions: podeEditar ? models.Permissions.Copy : models.Permissions.Read,
        settings: {
          useCustomSaveAsDialog: podeEditar ? true : undefined,
          panes: {
            pageNavigation: { visible: !!showFilterNav, position: models.PageNavigationPosition.Left },
            filters: { visible: !!showFilterNav, expanded: false },
            visualizations: { visible: podeEditar, expanded: false },
            fields: { visible: podeEditar, expanded: false }
          },
          bars: {
            statusBar: { visible: true },
            actionBar: { visible: true }
          }
        }
      });

      reportInstanceRef.current = reportRef;
      onReportReadyRef.current && onReportReadyRef.current(reportRef);

      if (!podeEditar) {
        reportRef.off('loaded');
        reportRef.on('loaded', () => {
          reportRef.updateSettings({
            panes: {
              visualizations: { visible: false },
              fields: { visible: false }
            }
          });
        });
      }

      reportRef.off('saveAsTriggered');
      reportRef.on('saveAsTriggered', () => {
        setAlert({
          message: 'A opção "Salvar como" está desabilitada.',
          type: 'warning'
        });
      });

      reportRef.off('error');
      reportRef.on('error', evt => {
        const det = (evt && (evt.detail || evt)) || {};
        const msg = String(det.message || det.detailedMessage || '').toLowerCase();
        const isExpired =
          msg.includes('tokenexpired') ||
          msg.includes('token expired') ||
          msg.includes('access token has expired') ||
          msg.includes('clienterror_tokenexpired');
        if (isExpired) onTokenExpiredRef.current();
      });

      return () => {
        reportInstanceRef.current = null;
        if (containerRef.current) powerbi.reset(containerRef.current);
      };
    }, [id, url, showFilterNav, exibeEdicao, powerbi]);

    return <div ref={containerRef} className="dashBoardBI margin-top-25" />;
  }
);

export default DashBordPowerBI;
